export { default } from './Calculator';
export { default as adapter } from './adapter';
